import React from 'react';
import SlateCheckbox from '../Shared/SlateCheckbox';
import SlateSelect from '../Shared/SlateSelect';

var SettingsOptions = function(props) {
  var includeHeaderRow = props.includeHeaderRow;
  var onChange = props.onChange;
  var t = props.t;
  var disabled = props.disabled;
  var currentTimeZone = props.currentTimeZone;
  var timeZones = props.timeZones;
  var onTimeZoneChange = props.onTimeZoneChange;

  return (
    <div>
      <SlateCheckbox
        label={t('settings:includeHeaderRow')}
        description={t('settings:includeHeaderRowDescr')}
        checked={includeHeaderRow}
        onChange={onChange}
        disabled={disabled}
      />

      <div style={{ marginTop: 24 }}>
        <label style={{ display: 'block', fontSize: 14, fontWeight: 500, color: '#374151', marginBottom: 6 }}>
          Export Timezone
        </label>
        <p style={{ fontSize: 13, color: '#6b7280', marginTop: 0, marginBottom: 10 }}>
          Dates and times will be converted to this timezone
        </p>
        <div style={{ display: 'inline-block', width: 420 }}>
          <SlateSelect
            defaultValue={currentTimeZone}
            options={timeZones}
            onChange={onTimeZoneChange}
            placeholder="Select timezone..."
            searchable
            dropUp
            disabled={disabled}
          />
        </div>
      </div>
    </div>
  );
};

export default SettingsOptions;
